export let dataset = [{
  source: [
    ['product', '2015', '2016', '2017'],
    ['Matcha Latte', 43.3, 85.8, 93.7],
    ['Milk Tea', 83.1, 73.4, 55.1],
    ['Cheese Cocoa', 86.4, 65.2, 82.5],
    ['Walnut Brownie', 72.4, 53.9, 39.1]
  ]
}]

export let legendItemStyle = function ({ v }) {
  return {
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      color: 'rgba(255, 255, 255, 0.6)',
      padding: [0, 0, 25, 0]
    }
  }
}
